import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { COLUMNS } from "./columnTrans";
import Header from "../../layout/Header";
import { getSchemaList } from "../../../actions/auth";
import { schema } from "../campaigns/services";
import TransactionPaginated from "./TransactionPaginated";

function TransactionSchema() {
    const [formData, setFormData] = useState([]);
    const [response, setResponse] = useState([]);

    const [loader, setLoader] = useState(false);
    const updateData = () => {
        setLoader(true)
        const token = JSON.parse(localStorage.getItem("token_gen"));
        let schemaName = localStorage.getItem("schemaName");
        schemaName = schemaName?.split(" ").join("");
        schema(token?.access_token, schemaName).then((res) => {
            setResponse(res?.data?.schema?.properties)
            setLoader(false)
        });
    }
    useEffect(() => {
        if (response) {
            const tempData = Object.keys(response)?.map((key) => {
                const field = response[key];
                return {
                    ...field,
                    fieldName: key,
                    displayName: field.fielddisplayname,
                    IsMobileField: field.IsMobileField === true ? "True" : "False",
                    isuniqueidentifier: field.isuniqueidentifier === true ? "True" : "False",
                    isrequired: field.isRequired === true ? "True" : "False",
                    action:
                        field.fielddisplayname === "Transaction Date" ||
                            field.fielddisplayname === "Transaction type" ||
                            field.fielddisplayname === "schemacode" ? (
                            <span
                                className="edit_btn"
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    color: "#ccc",
                                    cursor: "not-allowed",
                                    pointerEvents: "none",
                                }}
                            >
                                <i className="fa-solid fa-pen"></i>
                            </span>
                        ) : (
                            <Link
                                className="edit_btn"
                                state={{ key, field }}
                                to="/transactionSchema"
                                style={{ display: "flex", justifyContent: "center" }}
                                csvalue="Edit"
                            >
                                <i className="fa-solid fa-pen"></i>
                                <div className="show_div">Edit</div>
                            </Link>
                        )
                    // isSignUp: field.isSignUp === true ?"True" : "False",
                    // isSignUp: field.isSignUp === true ?"True" : "False",


                };
            });
            setFormData(tempData);
        }
    }, [response]);



    useEffect(() => {
        updateData()
    }, [])


    return (
        <>
            <Header name={"Transaction Schema"} />
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}
            <div className="dashboard__content">
                <div className="container-fluid">
                    <div className="row">
                        {/* <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div className="dashboard__heading">
                                <div className="dashboard__headingLeft">
                                    <div className="dashboard__headingContent">
                                        <Link to="/create-Transaction">
                                            <Button id="voucher" className="btn btn-primary btn-lg">
                                                Create Transaction Schema
                                            </Button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        <div className="dashboard__customersCard">
                            <div className="dashboard__header">
                                <div className="dashboard__left">
                                    <h4 id="voucher_details">Transaction Schema Details</h4>
                                </div>
                            </div>
                            <div className="dashboard__body"> <TransactionPaginated data={formData ? formData : []} columns={COLUMNS} /></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};


export default TransactionSchema